/**
 * DevExtreme (esm/events/core/event_registrator_callbacks.js)
 * Version: 23.2.3
 * Build date: Tue Nov 28 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import MemorizedCallbacks from "../../core/memorized_callbacks";
export default new MemorizedCallbacks;
